import { ForbidCircleIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { useHasPermission } from '@vlabs/permissions';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { BlockUserProps } from '../types';
import { useBlockUser } from './useBlockUser';

type BlockUserIconButtonProps = BlockUserProps & Omit<IconButtonProps, 'onClick'>;

const displayName = 'BlockUserIconButton';
const testid = buildTestid(displayName);

function BlockUserIconButton({
  userId,
  'data-testid': dataTestId = undefined,
  ...props
}: BlockUserIconButtonProps): JSX.Element | null {
  const hasAccess = useHasPermission('users', 'update');
  if (!hasAccess) return null;

  const blockUser = useBlockUser({ userId });
  return (
    <IconButton
      icon={<ForbidCircleIcon />}
      kind="negative"
      onClick={blockUser}
      variant="flat"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

BlockUserIconButton.displayName = displayName;

export { BlockUserIconButton };
